import { Directive, ElementRef, Input, SimpleChanges, OnChanges, OnDestroy, OnInit, Inject } from "@angular/core";
import { VgAPI } from "videogular2/core";
import { IHLSConfig } from './hls-config';
import { Subscription } from 'rxjs/Subscription';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

declare let Hls;

@Directive({
    selector: '[vdgmHls]'
})
export class VdgmHLS implements OnInit, OnChanges, OnDestroy {
    @Input() vdgmHls: string;

    vgFor: string;
    target: any;
    hls: any;
    preload: boolean;
    crossorigin: string;
    config: IHLSConfig;
    subscriptions: Subscription[] = [];

    private useNativePlayer:boolean;

    constructor(private ref: ElementRef,
        public API: VgAPI,
        @Inject(APP_SETTINGS) private settings: Object) {
           this.useNativePlayer = this.settings["USE_NATIVE_VIDEOPLAYER"];
    }

    ngOnInit() {
        if (this.API.isPlayerReady) {
            this.onPlayerReady();
        }
        else {
            this.subscriptions.push(this.API.playerReadyEvent.subscribe(() => this.onPlayerReady()));
        }
    }

    onPlayerReady() {
        this.crossorigin = this.ref.nativeElement.getAttribute('crossorigin');
        this.preload = this.ref.nativeElement.getAttribute('preload') !== 'none';
        this.vgFor = this.ref.nativeElement.getAttribute('vgFor');
        this.target = this.API.getMediaById(this.vgFor);

        this.config = <IHLSConfig>{
            autoStartLoad: this.preload,
            enableCEA708Captions: false,
            enableWebVTT: false
        };

        if (this.crossorigin === 'use-credentials') {
            this.config.xhrSetup = (xhr, url) => {
                // Send cookies
                xhr.withCredentials = true;
            };
        }

        this.createPlayer();

        if (!this.preload) {
            this.subscriptions.push(
                this.API.subscriptions.play.subscribe(
                    () => {
                        if (this.hls) {
                            this.hls.startLoad(0);
                        }
                    }
                )
            );
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['vdgmHls'].currentValue) {
            this.createPlayer();
        }
        else {
            this.destroyPlayer();
        }
    }

    createPlayer() {
        if (this.hls) {
            this.destroyPlayer();
        }

        // It's a HLS source
        if (!this.useNativePlayer && this.vdgmHls && this.vdgmHls.indexOf('.m3u8') > -1 && Hls.isSupported()) {
            let video: HTMLVideoElement = this.ref.nativeElement;

            this.hls = new Hls(this.config);
            this.hls.loadSource(this.vdgmHls);
            this.hls.attachMedia(video);
            //console.log(this.hls.subtitleTracks);
            this.hls.subtitleTrack = -1;
        }
        else {
            if (this.target && !!this.target.pause) {
                //this.target.pause();
                //this.target.seekTime(0);
                this.ref.nativeElement.src = this.vdgmHls;
            }
        }
    }

    destroyPlayer() {
        if (this.hls) {
            this.hls.destroy();
            this.hls = null;
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        this.destroyPlayer();
    }
}


// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/shared-directives/vdgm-hls.directive.ts